// A camel, modelled facing +X: a sandy body with two humps on tall legs, a
// long curved neck and a small head. Ported 1:1 from age-of-mcp's classic
// camel.ts, restoring its leg loop + body/hump/neck/head composition.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  const parts: Part[] = [];
  for (const [x, z] of [[0.07, 0.035], [0.07, -0.035], [-0.07, 0.035], [-0.07, -0.035]]) {
    parts.push({ geometry: new THREE.CylinderGeometry(0.009, 0.007, 0.2, 4),
      color: "#c8a36a", position: [x!, 0.1, z!] });
  }
  parts.push(
    { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#d4af74",
      position: [0, 0.2, 0], scale: [1.8, 0.95, 0.9] },              // body
    { geometry: new THREE.IcosahedronGeometry(0.03, 0), color: "#cfa86c",
      position: [0.03, 0.245, 0] },                                  // front hump
    { geometry: new THREE.IcosahedronGeometry(0.028, 0), color: "#cfa86c",
      position: [-0.04, 0.242, 0] },                                 // rear hump
    { geometry: new THREE.CylinderGeometry(0.018, 0.024, 0.16, 5), color: "#d4af74",
      position: [0.11, 0.26, 0], rotation: [0, 0, -0.6] },          // long neck
    { geometry: new THREE.IcosahedronGeometry(0.022, 0), color: "#dab97e",
      position: [0.17, 0.32, 0] },                                   // head
    { geometry: new THREE.ConeGeometry(0.01, 0.022, 4), color: "#caa066",
      position: [0.192, 0.31, 0], rotation: [0, 0, -Math.PI / 2] },    // muzzle
  );
  return parts;
}

export const camel = defineModel({
  id: "camel",
  scale: 2.43, // real-world size correction (see Model.scale)
  batchId: "standard",
  name: "Camel",
  tags: ["creature","camel","low-poly","age-of-mcp","classic"],
  summary: "Low-poly camel.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.16,
  fits: ["draft"],
  parts: () => partsFor(),
  animations: [],
});
